import { CheckCheck } from 'lucide-react';

import { convertUnixTimestamp } from '@/utils/unix';

import { Message } from '../types';

export const MessageBlock = ({
  isUserMessage,
  message,
}: {
  isUserMessage: boolean;
  message: Message;
}) => {
  return (
    <div
      className={`group flex ${isUserMessage && 'justify-end'} gap-x-2`}
      style={{ wordBreak: 'break-word' }}
    >
      <div
        className={`rounded-md ${
          isUserMessage ? 'bg-primary/30' : 'bg-secondary'
        } px-2.5 pb-1.5 pt-2 text-start`}
      >
        <div className="text-sm">
          {message.message}
          <span>
            <span
              className={`text-end text-xs italic ${
                isUserMessage ? 'text-primary' : 'text-muted-foreground'
              }  `}
            >
              {' '}
              {convertUnixTimestamp(message.timestamp).time}
            </span>
            {message.isSentByUserRead && (
              <span className="text-primary" title="Read">
                {' '}
                <CheckCheck size="16" className="inline-block" />
              </span>
            )}
          </span>
        </div>
      </div>
    </div>
  );
};
